<template>
  <div id="ilifestyleApp" class="c-content">
    <!-- <div class="c-content__imageBlock c-standard">
      <div class="c-content__imageBlock--text" style="width: calc(100% - 280px); min-height: auto; height: auto;">
        <p>{{ imgBlock.content }}</p>
      </div>
      <div class="c-content__imageBlock--image" style="width: 280px; text-align: center; min-height: auto; height: auto;">
        <img :src="imgBlock.img" alt="qr" style="height: auto; width: 40%">
        <p style="font-size: 13px;margin-top:5px">{{ imgBlock.downloadTxt }}</p>
      </div>
    </div> -->
    <div class="c-download flex" :style="{backgroundImage:'url('+ picBlock.bgImage +')'}">
      <div class="c-download__left" :style="{backgroundImage:'url('+ picBlock.leftImage +')'}"></div>
      <div class="c-download__right">
        <div class="c-download__imgBlock">
          <div v-for="(item, index) in picBlock.items" :key="index">
            <img :src="item.img" :alt="index">
          </div>
        </div>
        <div class="flex flexDirectionColumn">
          <p style="margin-top:50px"> {{ imgBlock.content }} </p>
          <img class="c-download__qr" :src="imgBlock.img" alt="qr">
          <span> {{ imgBlock.downloadTxt }} </span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  // import api from '../../api'
  // import axios from 'axios'
  export default {
    name: 'ilifestyleApp',
    data(){
      return {
        languageDefault: localStorage.getItem('lang') || 'zh_cn',

        imgBlock:{
          content: 'iLifestyle 是一款专为住宅居民和商业办公楼用户开发的具有楼宇通讯，门禁控制及安防报警功能的应用程序，旨在为用户打造安全舒适和便利的生活方式。主要具有音视频对讲、视频监控、报警推送、电梯控制及简单智能家居等功能，iLifestyle App轻量简洁的设计以及众多简单实用的功能一定会给你的生活带来更多便利和美好体验。',
          downloadTxt: '扫描二维码下载应用',
          img: require('../../assets/img/download_qr_ilifestyle.png'),
        },
        picBlock: {
          bgImage: require('../../assets/img/ilifestyle_bg.jpg'),
          leftImage: require('../../assets/img/ilifestyle_left.png'),
          items: [
            { img: require('../../assets/img/ilifestyle_screen01.png') },
            { img: require('../../assets/img/ilifestyle_screen02.png') },
            { img: require('../../assets/img/ilifestyle_screen03.png') },
            { img: require('../../assets/img/ilifestyle_screen04.png') },
          ],
        }
      }
    },
    computed: {

    },
    created () {

    },
    methods: {

    },
  }
</script>
